/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AreaNode } from '../model/areaNode';
import { SubareaNode } from '../model/subareaNode';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ChildPortfolioSkillsStatsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Mixin for django rest framework (djangorestframework) view sets to define basic fields for iSophi security.  It should be used together with ISophiEcosystemGranted permission class.  Class Attributes ---------------- isophi_permission_application_groups: List[str]     Check if application (where token was generated) belongs to required app groups.     Groups for applications are set in auth-portal,     typically group is \&quot;isophi-portal\&quot; &#x3D; BE applications managed by isophi,     but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_user_groups: List[str]     Check if user (owner of token) belongs to required user groups.     Groups for users are set in auth-portal,     typically groups are \&quot;admin\&quot;/\&quot;super-admin\&quot;, but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_query: List[enums.PermissionField]     List all data you want to load from token,     all this data are then available in field isophi_permission_data.     For usable fields and their meaning see enums.PermissionField. isophi_required_api_client_type: List[enums.ApiClientType]     Check if client with token is required type (isophi BE app, FE app, ...)     Multiple required types are joined by OR (1 type is enough to pass check). isophi_required_api_client_role: List[enums.ApiClientRole]     Check if client is required type (isophi admin, teacher, parent ...)     Multiple required roles are joined by OR (1 role is enough to pass check). isophi_permission_data: dict     Data loaded from token by specification in isophi_permission_query field. isophi_no_permission_check: dict     Set view_names, which are not checked for permission.     Set this field in format: {&#x27;GET&#x27;: [&#x27;view_name&#x27;, ...], &#x27;POST&#x27;: [], ...}
     * @param childUuid Filter by one or more child UUIDs
     * @param dateFrom Filter stats from this date
     * @param dateTo Filter stats until this date
     * @param groupUuid Filter by group UUID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioAreaTreeAreaList(childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AreaNode>>;
    public childPortfolioAreaTreeAreaList(childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AreaNode>>>;
    public childPortfolioAreaTreeAreaList(childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AreaNode>>>;
    public childPortfolioAreaTreeAreaList(childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('date_from', <any>dateFrom);
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('date_to', <any>dateTo);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AreaNode>>('get',`${this.basePath}/child-portfolio/area-tree/area/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Mixin for django rest framework (djangorestframework) view sets to define basic fields for iSophi security.  It should be used together with ISophiEcosystemGranted permission class.  Class Attributes ---------------- isophi_permission_application_groups: List[str]     Check if application (where token was generated) belongs to required app groups.     Groups for applications are set in auth-portal,     typically group is \&quot;isophi-portal\&quot; &#x3D; BE applications managed by isophi,     but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_user_groups: List[str]     Check if user (owner of token) belongs to required user groups.     Groups for users are set in auth-portal,     typically groups are \&quot;admin\&quot;/\&quot;super-admin\&quot;, but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_query: List[enums.PermissionField]     List all data you want to load from token,     all this data are then available in field isophi_permission_data.     For usable fields and their meaning see enums.PermissionField. isophi_required_api_client_type: List[enums.ApiClientType]     Check if client with token is required type (isophi BE app, FE app, ...)     Multiple required types are joined by OR (1 type is enough to pass check). isophi_required_api_client_role: List[enums.ApiClientRole]     Check if client is required type (isophi admin, teacher, parent ...)     Multiple required roles are joined by OR (1 role is enough to pass check). isophi_permission_data: dict     Data loaded from token by specification in isophi_permission_query field. isophi_no_permission_check: dict     Set view_names, which are not checked for permission.     Set this field in format: {&#x27;GET&#x27;: [&#x27;view_name&#x27;, ...], &#x27;POST&#x27;: [], ...}
     * @param uuid 
     * @param childUuid Filter by one or more child UUIDs
     * @param dateFrom Filter stats from this date
     * @param dateTo Filter stats until this date
     * @param groupUuid Filter by group UUID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioAreaTreeAreaRetrieve(uuid: string, childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'body', reportProgress?: boolean): Observable<AreaNode>;
    public childPortfolioAreaTreeAreaRetrieve(uuid: string, childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AreaNode>>;
    public childPortfolioAreaTreeAreaRetrieve(uuid: string, childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AreaNode>>;
    public childPortfolioAreaTreeAreaRetrieve(uuid: string, childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling childPortfolioAreaTreeAreaRetrieve.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('date_from', <any>dateFrom);
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('date_to', <any>dateTo);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AreaNode>('get',`${this.basePath}/child-portfolio/area-tree/${encodeURIComponent(String(uuid))}/area/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Mixin for django rest framework (djangorestframework) view sets to define basic fields for iSophi security.  It should be used together with ISophiEcosystemGranted permission class.  Class Attributes ---------------- isophi_permission_application_groups: List[str]     Check if application (where token was generated) belongs to required app groups.     Groups for applications are set in auth-portal,     typically group is \&quot;isophi-portal\&quot; &#x3D; BE applications managed by isophi,     but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_user_groups: List[str]     Check if user (owner of token) belongs to required user groups.     Groups for users are set in auth-portal,     typically groups are \&quot;admin\&quot;/\&quot;super-admin\&quot;, but there can be others.     Multiple required groups are joined by OR (1 group is enough to pass check). isophi_permission_query: List[enums.PermissionField]     List all data you want to load from token,     all this data are then available in field isophi_permission_data.     For usable fields and their meaning see enums.PermissionField. isophi_required_api_client_type: List[enums.ApiClientType]     Check if client with token is required type (isophi BE app, FE app, ...)     Multiple required types are joined by OR (1 type is enough to pass check). isophi_required_api_client_role: List[enums.ApiClientRole]     Check if client is required type (isophi admin, teacher, parent ...)     Multiple required roles are joined by OR (1 role is enough to pass check). isophi_permission_data: dict     Data loaded from token by specification in isophi_permission_query field. isophi_no_permission_check: dict     Set view_names, which are not checked for permission.     Set this field in format: {&#x27;GET&#x27;: [&#x27;view_name&#x27;, ...], &#x27;POST&#x27;: [], ...}
     * @param uuid 
     * @param childUuid Filter by one or more child UUIDs
     * @param dateFrom Filter stats from this date
     * @param dateTo Filter stats until this date
     * @param groupUuid Filter by group UUID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public childPortfolioAreaTreeSubareaRetrieve(uuid: string, childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'body', reportProgress?: boolean): Observable<SubareaNode>;
    public childPortfolioAreaTreeSubareaRetrieve(uuid: string, childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubareaNode>>;
    public childPortfolioAreaTreeSubareaRetrieve(uuid: string, childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubareaNode>>;
    public childPortfolioAreaTreeSubareaRetrieve(uuid: string, childUuid?: Array<string>, dateFrom?: string, dateTo?: string, groupUuid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uuid === null || uuid === undefined) {
            throw new Error('Required parameter uuid was null or undefined when calling childPortfolioAreaTreeSubareaRetrieve.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (childUuid) {
            childUuid.forEach((element) => {
                queryParameters = queryParameters.append('child_uuid', <any>element);
            })
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('date_from', <any>dateFrom);
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('date_to', <any>dateTo);
        }
        if (groupUuid !== undefined && groupUuid !== null) {
            queryParameters = queryParameters.set('group_uuid', <any>groupUuid);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SubareaNode>('get',`${this.basePath}/child-portfolio/area-tree/${encodeURIComponent(String(uuid))}/subarea/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
